import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[uiItemContentHost]',
    standalone: false,
})
export class ItemContentDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}
